<app-layer-config-collapsible-category
  class="border-bottom border-darkgray"
  description="Trip Statistics"
  storageKey="vzo-speed-map-tile-segment"
>
  <app-layer-control-item
    description="Road Coverage"
    [isLayerVisibile]="isRoadCoverageLayerVisible"
    [layerId]="layerIds.RoadCoverage.name"
    icon="street-check"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
  <app-layer-control-item
    description="Speed Profile"
    [isLayerVisibile]="isSpeedProfileLayerVisible"
    [layerId]="layerIds.SpeedProfile.name"
    icon="speedometer-high"
    (visibilityToggled)="toggleLayerVisbility($event)"
  ></app-layer-control-item>
</app-layer-config-collapsible-category>
